import { render, staticRenderFns } from "./SocialMediaShare.vue?vue&type=template&id=2ae11be2"
import script from "./SocialMediaShare.vue?vue&type=script&lang=ts"
export * from "./SocialMediaShare.vue?vue&type=script&lang=ts"
import style0 from "./SocialMediaShare.vue?vue&type=style&index=0&id=2ae11be2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VContainer,VTooltip})
